/* global axios */
import ApiClient from './ApiClient';

class AdditionalAttributesAPI extends ApiClient {
  constructor() {
    super('contacts_additional_attributes', { accountScoped: true });
  }

  getCompanyNames() {
    return axios.get(`${this.url}?q=company_name`);
  }
}

export default new AdditionalAttributesAPI();
